import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '../components/ui/button';
import { CheckCircle, FilePdf, FileXls, PaperPlaneRight } from '@phosphor-icons/react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CommunicationsSentPage = () => {
  const { axiosInstance } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      const { data } = await axiosInstance.get('/communications/sent-list');
      setItems(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="inline-block h-12 w-12 animate-spin rounded-full border-4 border-solid border-[#0A2540] border-r-transparent"></div>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto space-y-6" data-testid="communications-sent-page">
      <div>
        <h1 className="text-4xl font-extrabold tracking-tighter text-slate-900">Comunicazioni Inviate</h1>
        <p className="mt-2 text-sm text-slate-600">Storico delle comunicazioni di apertura inviate via PEC alle UADM</p>
      </div>

      {items.length === 0 ? (
        <div className="bg-slate-50 border border-slate-200 rounded-sm p-8 text-center">
          <PaperPlaneRight size={32} className="mx-auto text-slate-400 mb-3" />
          <p className="text-sm text-slate-600">Nessuna comunicazione inviata al momento.</p>
        </div>
      ) : (
        <div className="bg-white border border-slate-200 rounded-sm overflow-hidden">
          <table className="w-full" data-testid="sent-table">
            <thead>
              <tr className="bg-slate-50 border-b border-slate-200">
                <th className="text-left px-6 py-3 text-xs font-semibold text-slate-600 uppercase tracking-wider">Provincia</th>
                <th className="text-right px-6 py-3 text-xs font-semibold text-slate-600 uppercase tracking-wider">POD</th>
                <th className="text-right px-6 py-3 text-xs font-semibold text-slate-600 uppercase tracking-wider">Accise Annue</th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-slate-600 uppercase tracking-wider">UADM</th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-slate-600 uppercase tracking-wider">PEC Destinatario</th>
                <th className="text-left px-6 py-3 text-xs font-semibold text-slate-600 uppercase tracking-wider">Data Invio</th>
                <th className="text-center px-6 py-3 text-xs font-semibold text-slate-600 uppercase tracking-wider">Documenti</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {items.map((item) => (
                <tr key={item.province} className="hover:bg-slate-50 transition-colors">
                  <td className="px-6 py-4">
                    <div className="flex items-center gap-2">
                      <CheckCircle size={16} weight="fill" className="text-green-600" />
                      <span className="text-sm font-bold text-slate-900">{item.province}</span>
                    </div>
                  </td>
                  <td className="px-6 py-4 text-sm text-slate-700 text-right">{item.pod_count}</td>
                  <td className="px-6 py-4 text-sm text-slate-700 text-right font-mono">
                    EUR {(item.total_annual_excise || 0).toLocaleString('it-IT', { minimumFractionDigits: 2 })}
                  </td>
                  <td className="px-6 py-4 text-xs text-slate-600">{item.customs_office}</td>
                  <td className="px-6 py-4 text-xs text-slate-600 break-all">{item.customs_pec}</td>
                  <td className="px-6 py-4 text-xs text-slate-700">
                    {item.sent_at ? new Date(item.sent_at).toLocaleDateString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '-'}
                  </td>
                  <td className="px-6 py-4 text-center">
                    <div className="flex justify-center gap-1">
                      {item.has_pdf && (
                        <Button size="sm" variant="ghost" className="h-7 w-7 p-0"
                          onClick={() => window.open(`${API_URL}/api/communications/${item.province}/download-pdf`, '_blank')}>
                          <FilePdf size={16} className="text-red-600" />
                        </Button>
                      )}
                      {item.has_excel && (
                        <Button size="sm" variant="ghost" className="h-7 w-7 p-0"
                          onClick={() => window.open(`${API_URL}/api/communications/${item.province}/download-excel`, '_blank')}>
                          <FileXls size={16} className="text-green-600" />
                        </Button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CommunicationsSentPage;
